import { Component, Input, OnDestroy, NgZone, ChangeDetectorRef, ViewEncapsulation, ElementRef, Directive, Output, EventEmitter } from '@angular/core';
import { EnpsControl } from '@common/controls/enps-control/enps-control';
import { TimeoutQueue } from '@common/services/timeout-queue';
import { AppService } from '@suite/app.service';
import { MultiValue } from '@common/data-models/complex-types/multi-value';

import { GlobalTablesService } from "@common/services/global-tables-service";
import { VisualStateService } from "@common/services/visual-state-service";
import { MatSelectionListChange } from '@angular/material/list';
import { FormControl } from '@angular/forms';
import { Observable} from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { optionContainsTerm } from '../../utils/util';

@Directive({
    selector: 'customChip'
})
export class CheckListItemsDirective { }

@Component({
    selector: 'check-list',
    templateUrl: './check-list.html',
    styleUrls: ['./check-list.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'st-check-list'
    }
})

export class CheckList extends EnpsControl<MultiValue<string> | Array<any>> implements OnDestroy {

    checkListFilter = new FormControl('');
    filteredOptions: Observable<{ id: string, title: string, selectable: boolean }[]>;

    public maxItemsToShow: number = 1;

    @Input() public itemList: { id: string, title: string, selectable: boolean }[] = [];
    @Input() labelTranslationPrefix: string = '';

    public get items(): string[] {
        if (this.asCustomField && this.itemsToShow?.length > 0) {
            return this.itemsToShow;
        }
        return this.value;
    }

    public itemsToShow: string[] = [];
    public itemsAsTooltip: string = '';
    public set value(v: string[]) {
        super.value = v;
        if (this.asCustomField) {
            this.calculateTagsToShow();
        }
    }

    private calculateTagsToShow() {
        if (this.asCustomField) {
            this.itemsToShow = this._value?.slice(0, this.maxItemsToShow);
            this.itemsAsTooltip = this._value?.slice(this.maxItemsToShow)
                .map(item => this.getItemLabel(item)).join('\n');
        }
    }

    public get value(): string[] {
        return super.value;
    }

    @Output() public selectionChange = new EventEmitter<any>();

    onMenuOpened() {
        super.onMenuOpened();
        this.filteredOptions = this.checkListFilter.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '')),
        );
    }

    constructor(
        public appService: AppService,
        ngZone: NgZone,
        changeDetectorRef: ChangeDetectorRef,
        timeoutQueue: TimeoutQueue,
        globalTablesService: GlobalTablesService,
        public visualStateService: VisualStateService,
        elementRef: ElementRef
    ) {
        super(appService, ngZone, changeDetectorRef, timeoutQueue, globalTablesService, elementRef);
    }

    private _filter(value: string): { id: string, title: string, selectable: boolean }[] {
        return this.itemList.filter(option => optionContainsTerm(option.title, value) || optionContainsTerm(option.id, value))
    }

    public getItemLabel(item: any) {
        return this.itemList.find(option => (option.id?.toLowerCase().includes(item?.toLowerCase())))?.title;
    }

    onSelectionChange(event: MatSelectionListChange) {
        let value = 0;
        if (event.options.length > 0) {
            value = event.options[0].value;
        }
        this.value = event.source.selectedOptions.selected.map((item) => item.value);
        this.isValueChanged = true;
        this.selectionChange.emit({ id: value, state: this.value });
    }

    onValueChanged() {
        this.checkListFilter.setValue('');
        if (this.isValueChanged) {
            this.changed.emit(this.value);
            this.isValueChanged = false;
        }
    }

    onRemove(item: string): void {
        const index = this.value.indexOf(item);

        if (index >= 0) {
            this.value = this.value.filter((item, idx) => idx != index);
            this.calculateTagsToShow();
        }
        this.selectionChange.emit({ id: this.value, state: this.value });

        setTimeout(()=>{
            this.changed.emit(this.value);
        }, 0);
    }
}
